var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"be-splash-screen"},[_c('div',{class:`be-wrapper ${_vm.wrapperClass}`},[_c('div',{staticClass:"be-content"},[_c('div',{staticClass:"main-content container-fluid"},[_c('div',{staticClass:"splash-container"},[_vm._t("default"),(!!_vm.$slots.footer)?_c('div',{staticClass:"splash-footer"},[_vm._t("footer")],2):_vm._e()],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }